<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="card pb-2 pt-4">
            <div class="grid justify-content-between">
              <div class="col-12 md:col-6 lg:col-5">
                <div class="">
                  <div class="flex align-items-center">
                    <div class="ml-2">
                      <div class="text-xl text-primary font-bold">
                        Applications
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-5 lg:col-5">
                <span class="p-input-icon-left w-full">
                  <i class="pi pi-search" />
                  <InputText
                    outlined
                    dense
                    placeholder="Search"
                    class="w-full"
                    v-model="searchInput"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid card pt-1 pb-0 px-1 mx-1">
          <div class="col-12 md:col-4 comp-grid">
            <div class="mb-2 nice-shadow-18">
              <api-data-source
                api-path="components_data/fund_applications_applicant_selected_grant_name_option_list"
              >
                <template v-slot="req">
                  <div class="q-pa-sm">
                    <Dropdown
                      :filter="true"
                      class="w-full"
                      :loading="req.loading"
                      @input="
                        setFilter(
                          req.response,
                          'fund_applications_applicant_selected_grant_name'
                        )
                      "
                      v-model="
                        filters.fund_applications_applicant_selected_grant_name
                      "
                      optionLabel="label"
                      optionValue="value"
                      :options="req.response"
                      placeholder="Name of Fund ..."
                    >
                    </Dropdown>
                  </div>
                </template>
              </api-data-source>
            </div>
          </div>
          <div class="md:col-2 col-12 comp-grid">
            <div class="mb-2 nice-shadow-18">
              <div class="q-pa-sm">
                <Dropdown
                  class="w-full"
                  @input="
                    setFilter(
                      $menus.fund_applicationsgenderItems,
                      'fund_applications_gender'
                    )
                  "
                  v-model="filters.fund_applications_gender"
                  optionLabel="label"
                  optionValue="value"
                  :options="$menus.fund_applicationsgenderItems"
                  placeholder="Gender ..."
                >
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="md:col-3 col-12 comp-grid">
            <div class="mb-2 nice-shadow-18">
              <div class="q-pa-sm">
                <Dropdown
                  class="w-full"
                  @input="
                    setFilter(
                      $menus.fund_applicationsapplicant_in_schoolItems,
                      'fund_applications_applicant_in_school'
                    )
                  "
                  v-model="filters.fund_applications_applicant_in_school"
                  optionLabel="label"
                  optionValue="value"
                  :options="$menus.fund_applicationsapplicant_in_schoolItems"
                  placeholder="Institution Enrollments ..."
                >
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="md:col-3 col-12 comp-grid">
            <div class="mb-2 nice-shadow-18">
              <div class="q-pa-sm">
                <Dropdown
                  class="w-full"
                  @input="
                    setFilter(
                      $menus.fund_applicationsapproval_statusItems,
                      'fund_applications_approval_status'
                    )
                  "
                  v-model="filters.fund_applications_approval_status"
                  optionLabel="label"
                  optionValue="value"
                  :options="$menus.fund_applicationsapproval_statusItems"
                  placeholder="Application Status ..."
                >
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="flex">
              <div v-if="searchText" class="p-2 text-500 flex-grow-1 m-1 mb-3">
                Search
                <Chip
                  class="font-medium px-2 py-1"
                  removable
                  @remove="clearSearch()"
                  >{{ searchText }}</Chip
                >
              </div>
              <div
                v-if="filters.fund_applications_applicant_selected_grant_name"
                class="p-2 text-500 flex-grow-1 m-1 mb-3"
              >
                Fund Name
                <Chip
                  class="font-medium px-2 py-1"
                  removable
                  @remove="
                    filters.fund_applications_applicant_selected_grant_name = ''
                  "
                >
                  <span
                    v-if="
                      filtersLabel.fund_applications_applicant_selected_grant_name
                    "
                    >{{
                      filtersLabel.fund_applications_applicant_selected_grant_name.toString()
                    }}</span
                  >
                  <span v-else>{{
                    filters.fund_applications_applicant_selected_grant_name
                  }}</span>
                </Chip>
              </div>
              <div
                v-if="filters.fund_applications_gender"
                class="p-2 text-500 flex-grow-1 m-1 mb-3"
              >
                Gender
                <Chip
                  class="font-medium px-2 py-1"
                  removable
                  @remove="filters.fund_applications_gender = ''"
                >
                  <span v-if="filtersLabel.fund_applications_gender">{{
                    filtersLabel.fund_applications_gender.toString()
                  }}</span>
                  <span v-else>{{ filters.fund_applications_gender }}</span>
                </Chip>
              </div>
              <div
                v-if="filters.fund_applications_applicant_in_school"
                class="p-2 text-500 flex-grow-1 m-1 mb-3"
              >
                Applicant In School
                <Chip
                  class="font-medium px-2 py-1"
                  removable
                  @remove="filters.fund_applications_applicant_in_school = ''"
                >
                  <span
                    v-if="filtersLabel.fund_applications_applicant_in_school"
                    >{{
                      filtersLabel.fund_applications_applicant_in_school.toString()
                    }}</span
                  >
                  <span v-else>{{
                    filters.fund_applications_applicant_in_school
                  }}</span>
                </Chip>
              </div>
              <div
                v-if="filters.fund_applications_approval_status"
                class="p-2 text-500 flex-grow-1 m-1 mb-3"
              >
                Approval Status
                <Chip
                  class="font-medium px-2 py-1"
                  removable
                  @remove="filters.fund_applications_approval_status = ''"
                >
                  <span v-if="filtersLabel.fund_applications_approval_status">{{
                    filtersLabel.fund_applications_approval_status.toString()
                  }}</span>
                  <span v-else>{{
                    filters.fund_applications_approval_status
                  }}</span>
                </Chip>
              </div>
            </div>
            <div class="">
              <div>
                <template v-if="showBreadcrumbs && $route.query.tag">
                  <Breadcrumb
                    :home="{ icon: 'pi pi-home', to: '/' }"
                    :model="pageBreadCrumb"
                  />
                </template>
                <div class="grid">
                  <!-- Master Page Start -->
                  <div class="col-12">
                    <!-- page records template -->
                    <div class="page-records" v-if="!loading">
                      <DataTable
                        :lazy="true"
                        :loading="loading"
                        :value="records"
                        dataKey="applicant_selected_grant_id"
                        @sort="onSort($event)"
                        class=""
                        :showGridlines="false"
                        :rowHover="true"
                        responsiveLayout="stack"
                      >
                        <!-- <Column
                          field="passport_picture"
                          header="Passport Picture"
                        >
                          <template #body="{ data }">
                            <image-viewer
                              image-size="medium"
                              image-preview-size=""
                              :src="data.passport_picture"
                              width="30px"
                              height="30px"
                              :num-display="1"
                            >
                            </image-viewer>
                          </template>
                        </Column> -->
                        <Column field="application_ref" header="ApplicationID">
                          <template #body="{ data }">
                            <router-link
                              :to="`/fund_applications/view/${data.applicant_selected_grant_id}`"
                            >
                              {{ data.application_ref }}
                            </router-link>
                          </template>
                        </Column>
                         <Column field="title" header="Title">
                          <template #body="{ data }">
                            {{ data.title }}
                          </template>
                        </Column>
                        <Column field="firstname" header="FirstName">
                          <template #body="{ data }">
                          <router-link
                              :to="`/fund_applications/view/${data.applicant_selected_grant_id}`"
                            >
                            {{ data.firstname }}
                          </router-link>
                          </template>
                        </Column>
                        <Column field="lastname" header="LastName">
                          <template #body="{ data }">
                          <router-link
                              :to="`/fund_applications/view/${data.applicant_selected_grant_id}`"
                            >
                            {{ data.lastname }}
                          </router-link>
                          </template>
                        </Column>
                        <!-- <Column field="othernames" header="OtherNames">
                          <template #body="{ data }">
                            {{ data.othernames }}
                          </template>
                        </Column> -->
                        <Column field="gender" header="Gender" :sortable="true">
                          <template #body="{ data }">
                            {{ data.gender }}
                          </template>
                        </Column>
                        <Column
                          field="applicant_selected_grant_name"
                          header="Scholarship"
                        >
                          <template #body="{ data }">
                            {{ data.applicant_selected_grant_name }}
                          </template>
                        </Column>
                        <!-- <Column
                          field="applicant_selected_grant_type"
                          header="Fund Type"
                          :sortable="true"
                        >
                          <template #body="{ data }">
                            {{ data.applicant_selected_grant_type }}
                          </template>
                        </Column> -->
                        <Column field="telephone" header="Telephone">
                          <template #body="{ data }">
                            {{ data.telephone }}
                          </template>
                        </Column>
                        <Column
                          field="approval_status"
                          header="Approval"
                        >
                          <template #body="{ data }">
                            <div
                              v-if="data.approval_status == 'Approved'"
                              class="text-green-500"
                            >
                              {{ data.approval_status }}
                            </div>
                            <div
                              v-else-if="data.approval_status == 'Declined'"
                              class="text-pink-500"
                            >
                              {{ data.approval_status }}
                            </div>
                            <div v-else class="text-yellow-600">
                              Pending
                            </div>
                          </template>
                        </Column>
                        <Column
                          headerStyle="width: 3em"
                          headerClass="text-center"
                        >
                          <template #body="{ data }">
                            <SplitButton
                              class="p-button p-button-raised p-button-text p-button-sm"
                              :model="getActionMenuModel(data)"
                            >
                              <i></i>
                            </SplitButton>
                          </template>
                        </Column>
                      </DataTable>
                    </div>
                    <!-- page loading indicator -->
                    <template v-if="loading">
                      <div>
                        <DataTable
                          :value="[1, 2, 3, 4]"
                          responsiveLayout="scroll"
                        >
                          <Column style="width: 3rem">
                            <template #body>
                              <Skeleton shape="circle" size="2rem" />
                            </template>
                          </Column>
                          <Column>
                            <template #body>
                              <Skeleton />
                            </template>
                          </Column>
                          <Column>
                            <template #body>
                              <Skeleton borderRadius="16px" />
                            </template>
                          </Column>
                          <Column>
                            <template #body>
                              <Skeleton />
                            </template>
                          </Column>
                          <Column style="width: 3rem">
                            <template #body>
                              <Skeleton size="2rem" />
                            </template>
                          </Column>
                        </DataTable>
                      </div>
                    </template>
                    <!-- end of page loading indicator-->
                    <!-- Empty record -->
                    <template v-if="!loading && !records.length">
                      <div
                        class="p-3 my-3 text-500 text-lg font-medium text-center"
                      >
                        No record found
                      </div>
                    </template>
                    <!-- end of empty record-->
                    <!-- pagination component-->
                    <template v-if="showFooter">
                      <div class="">
                        <div v-show="!loading">
                          <div class="flex justify-content-between">
                            <div
                              class="flex justify-content-center flex-grow-0"
                            >
                              <div
                                class="m-2"
                                v-if="exportButton && records.length"
                              >
                                <Button
                                  @click="
                                    (event) =>
                                      this.exportPageRecords('xlsx', 'xlsx')
                                  "
                                  class="p-button-secondary"
                                  label="Export Data"
                                  title="Export Data"
                                  icon="pi pi-print"
                                />
                              </div>
                              <!-- <div
                                class="m-2"
                                v-if="exportButton && records.length"
                              >
                                <Button
                                  @click="
                                    (event) =>
                                      this.exportPageRecords(
                                        'xlsx',
                                        'xlsx',
                                        'exportnew'
                                      )
                                  "
                                  label="Export New Applications"
                                  title="Export New Applications"
                                  icon="pi pi-print"
                                />
                              </div> -->
                              <div v-if="records.length" class="m-2">
                                <import-data
                                  label="Select a file to import"
                                  ref="dataimport"
                                  upload-path="fund_applications/importdata"
                                  @importComplete="importComplete"
                                >
                                  <Button
                                    @click="$refs.dataimport.openDialog()"
                                    icon="pi pi-folder"
                                    label="Import Data"
                                  />
                                </import-data>
                              </div>
                            </div>
                            <div
                              v-if="paginate && totalPages > 1"
                              class="flex-grow-1 m-2"
                            >
                              <Paginator
                                @page="
                                  (event) => {
                                    pagination.page = event.page + 1;
                                  }
                                "
                                :rows="pagination.rowsPerPage"
                                :totalRecords="totalRecords"
                              >
                                <template #start>
                                  <span class="text-sm text-gray-500 px-2">
                                    Records
                                    <b
                                      >{{ recordsPosition }} of
                                      {{ totalRecords }}</b
                                    >
                                  </span>
                                </template>
                                <template #end> </template>
                              </Paginator>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- end of pagination component-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { defineAsyncComponent, ref } from "vue";
import { PageMixin } from "../../mixins/page.js";
import { ListPageMixin } from "../../mixins/listpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "listFundapplicationsPage",
  components: {},
  mixins: [PageMixin, ListPageMixin],
  props: {
    primaryKey: {
      type: String,
      default: "applicant_selected_grant_id",
    },
    pageName: {
      type: String,
      default: "fund_applications",
    },
    routeName: {
      type: String,
      default: "fund_applicationslist",
    },
    apiPath: {
      type: String,
      default: "fund_applications/index",
    },
    mergeRecords: {
      type: Boolean,
      default: false,
    },
    importButton: {
      type: Boolean,
      default: true,
    },
    multiCheckbox: {
      type: Boolean,
      default: false,
    },
    msgBeforeDelete: {
      type: String,
      default: "Are you sure you want to delete this record?",
    },
  },
  data() {
    return {
      filters: {
        fund_applications_applicant_selected_grant_name: "",
        fund_applications_gender: "",
        fund_applications_applicant_in_school: "",
        fund_applications_approval_status: "",
      },
      filtersLabel: {},
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        //set browser page title
        return "Fund Applications";
      },
    },
    records: {
      get: function () {
        return this.$store.getters["fund_applications/records"];
      },
      set: function (value) {
        this.$store.commit("fund_applications/setRecords", value);
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["fund_applications/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("fund_applications/setCurrentRecord", value);
      },
    },
  },
  watch: {
    apiUrl: function () {
      this.load();
    },
  },
  methods: {
    ...mapActions("fund_applications", ["fetchRecords", "deleteRecord"]),
    getActionMenuModel(data) {
      return [
        {
          label: "Approve",
          icon: "pi pi-check text-green-500",
          command: () => {
            this.updateRecord(data.applicant_selected_grant_id, "Approved");
          },
        },
        {
          label: "Decline",
          icon: "pi pi-times text-pink-500",
          command: () => {
            this.updateRecord(data.applicant_selected_grant_id, "Declined");
          },
        },
      ];
    },
    load: function () {
      if (!this.loading) {
        this.loading = true;
        this.currentRecord = null;
        let url = this.apiUrl;
        let payload = {
          url,
          merge: this.mergeRecords,
        };
        this.fetchRecords(payload).then(
          (response) => {
            this.loading = false;
            this.ready = true;
            this.totalRecords = response.total_records;
            this.recordCount = response.record_count;
            this.pagination.rowsNumber = this.totalRecords;
            window.scrollTo(0, 0);
          },
          (response) => {
            this.loading = false;
            this.showPageRequestError(response);
          }
        );
      }
    },
    updateRecord(id, approveStatus) {
      let url = "/applicant_selected_grants/edit/" + id;
      let payload = {
        approval_status: approveStatus,
      };
      this.$api.post(url, payload).then(
        (response) => {
          this.load();
        },
        (response) => {
          this.showPageRequestError(response);
        }
      );
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
